import React from 'react';
import PropTypes from 'prop-types';
import ExpandableModalPanel from 'components/consumer/ExpandableModalPanel';
import ShopByHeaderSection from 'components/consumer/ShopByHeaderSection';
import IconCheck from 'components/icons/iconCheck';

const ExpandableModalOptions = ({
  isOpen,
  label: groupLabel,
  onClose,
  options,
}) => (
  <ExpandableModalPanel isOpen={isOpen} onOverlayClick={onClose}>
    <div className="pl-[3.333vw] pr-[3.333vw] [border-bottom:1px_solid_#f1f1f1]">
      <div className="flex-wrap pt-4 px-0 pb-0 md:items-start md:flex md:min-h-[100px] md:mt-0 md:mb-0">
        <ShopByHeaderSection label={groupLabel}>
          <div className="text-base font-bold text-gray flex flex-col mx-0 my-[5px] w-full">
            {options.map(({ label, id, isSelected, onClick }) => (
              <button
                type="button"
                className="p-2.5 flex items-start justify-start bg-white border-0 text-black"
                key={id}
                onClick={onClick}
              >
                {label}{' '}
                {isSelected ? (
                  <IconCheck
                    className="h-[.9rem] ml-4 w-[.9rem] [&_path]:stroke-[#107c8c]"
                    color="#27919C"
                  />
                ) : (
                  ''
                )}
              </button>
            ))}
          </div>
        </ShopByHeaderSection>
      </div>
    </div>
  </ExpandableModalPanel>
);

ExpandableModalOptions.propTypes = {
  isOpen: PropTypes.bool,
  label: PropTypes.string,
  onClose: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      map: PropTypes.func,
      label: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      isSelected: PropTypes.bool,
      onClick: PropTypes.func,
    })
  ),
};

export default ExpandableModalOptions;
